/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseErrorConflictAllOfError
 */
export interface ResponseErrorConflictAllOfError {
    /**
     * 
     * @type {string}
     * @memberof ResponseErrorConflictAllOfError
     */
    code: ResponseErrorConflictAllOfErrorCodeEnum;
}


/**
 * @export
 */
export const ResponseErrorConflictAllOfErrorCodeEnum = {
    Conflict: 'conflict'
} as const;
export type ResponseErrorConflictAllOfErrorCodeEnum = typeof ResponseErrorConflictAllOfErrorCodeEnum[keyof typeof ResponseErrorConflictAllOfErrorCodeEnum];


/**
 * Check if a given object implements the ResponseErrorConflictAllOfError interface.
 */
export function instanceOfResponseErrorConflictAllOfError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ResponseErrorConflictAllOfErrorFromJSON(json: any): ResponseErrorConflictAllOfError {
    return ResponseErrorConflictAllOfErrorFromJSONTyped(json, false);
}

export function ResponseErrorConflictAllOfErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorConflictAllOfError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ResponseErrorConflictAllOfErrorToJSON(value?: ResponseErrorConflictAllOfError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

